import { useFlags } from 'launchdarkly-react-client-sdk';
import { MaggieFeatureFlags } from '../../../util/feature-flags';

/**
 * Single read of `showSummaryV2`. The flag decides between two whole designs of the Summary tab, so
 * it is consumed in a dozen components; routing them all through here keeps the flag's name in one
 * place, and makes removing the flag once V2 ships a single edit.
 *
 * To force V2 on locally, return `true` early — the bootstrap default in `index.tsx`'s
 * `getBootstrapFlags` is not enough, because LaunchDarkly replaces it once the client connects.
 */
export function useShowSummaryV2(): boolean {
  const { showSummaryV2 } = useFlags<MaggieFeatureFlags>();

  return showSummaryV2;
}
